export const api = {
  carbonTarget: {
    queryTargetList: '/bms/carbon/target/page.json',
    addTargetList: '/bms/carbon/target/add.json',
    updateTargetList: '/bms/carbon/target/update.json'
  },
  carbonTrading: {
    queryTradingList: '/bms/carbon/trade/page.json',
    addTradingList: '/bms/carbon/trade/add.json',
    updateTradingList: '/bms/carbon/trade/update.json'
  },
  fuelRelated: {
    queryFuelList: '/bms/carbon/emission/fuel/page.json',
    addFuelList: '/bms/carbon/emission/fuel/add.json',
    updateFuelList: '/bms/carbon/emission/fuel/update.json'
  },
  electricityEmissions: {
    queryElectricityList: '/bms/carbon/emission/power/page.json',
    addElectricityList: '/bms/carbon/emission/power/add.json',
    updateElectricityList: '/bms/carbon/emission/power/update.json'
  },
  carbonAccount: {
    queryStatistics: '/bms/carbon/monthly/statistics/page.json',
    exportStatistics: '/bms/carbon/monthly/statistics/export.json',
  },
  grasslands: {
    querySiteList: '/bms/carbon/reduction/site/page.json',
    updateSiteList: '/bms/carbon/reduction/site/update.json',
    addSiteList: '/bms/carbon/reduction/site/add.json',
  },
  cleanEnergy: {
    queryEnergyList: '/bms/carbon/reduction/energy/page.json',
    updateEnergyList: '/bms/carbon/reduction/energy/update.json',
    addEnergyList: '/bms/carbon/reduction/energy/add.json',
  },
  fuelConsumption: {
    queryFuel: '/bms/carbon/fuel/listFuel.json',
    addFuel: '/bms/carbon/fuel/addFuel.json',
    updateFuel: '/bms/carbon/fuel/updateFuel.json',
    delFuel: '/bms/carbon/fuel/deleteFuel.json',
    queryFuelUse: '/bms/carbon/fuel/queryFuelPage.json',
    addFuelInfo: '/bms/carbon/fuel/addFuelInfo.json',
    updateFuelInfo: '/bms/carbon/fuel/updateFuelInfo.json',
    delFuelInfo: '/bms/carbon/fuel/deleteFuelInfo.json',
    queryFuelById: '/bms/carbon/fuel/queryFuelById.json',
  }
};
